/* tslint:disable */
/* eslint-disable */
/**
 * Product Storage API
 * ### Poizon API Documentation  **Официальная документация Poizon API.**  #### 📚 Ресурсы  - [Официальный GitHub SDK](https://github.com/Poizon-API/public-api)  - [OpenApi JSON](https://poizon-api.com/api/product-storage/api-json)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { PriceDto } from './price-dto';

/**
 * 
 * @export
 * @interface ProductSourceDto
 */
export interface ProductSourceDto {
    /**
     * Product source title
     * @type {string}
     * @memberof ProductSourceDto
     */
    'title': string;
    /**
     * Source
     * @type {string}
     * @memberof ProductSourceDto
     */
    'source': ProductSourceDtoSourceEnum;
    /**
     * External ID
     * @type {string}
     * @memberof ProductSourceDto
     */
    'externalId'?: string;
    /**
     * Price information
     * @type {PriceDto}
     * @memberof ProductSourceDto
     */
    'price'?: PriceDto;
}

export const ProductSourceDtoSourceEnum = {
    Dewu: 'DEWU',
    Poizon: 'POIZON',
    Goat: 'GOAT',
    Shihuo: 'SHIHUO'
} as const;

export type ProductSourceDtoSourceEnum = typeof ProductSourceDtoSourceEnum[keyof typeof ProductSourceDtoSourceEnum];


